export enum PromotionType {
  Top = 'top-ad',
  Inline = 'inline-listing',
}
